import { render } from "./product-full.vue?vue&type=template&id=1f8d6b7a&ts=true"
import script from "./product-full.vue?vue&type=script&lang=ts"
export * from "./product-full.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__